export const tableButtonStyles = ({
  theme
}) => ({
  borderRadius: theme.space['100'],
  transition: 'background-color 150ms ease',
  '&:hover': {
    background: theme.color['fill-surface-default-hover']
  },
  color: theme.color['text-core-default']
});